// src/components/CookieConsentBanner.jsx
import CookieConsent from "react-cookie-consent";

const CookieConsentForm = () => {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept Cookies"
      declineButtonText="Decline Cookies"
      cookieName="customCookieConsent"
      style={{ background: "#333", textAlign: "center" }}
      buttonStyle={{
        background: "#fb8501",
        color: "#fff",
        fontSize: "12px",
        padding: "10px 20px",
        borderRadius: "5px",
      }}
      declineButtonStyle={{
        background: "#9e9e9e",
        color: "#fff",
        fontSize: "12px",
        padding: "10px 20px",
        borderRadius: "5px",
      }}
      expires={20}
      enableDeclineButton
    >
      We use cookies to ensure you get the best experience on our website.{" "}
      <a href="/PrivacyPolicy" style={{ color: "#fb8501" }}>
        Learn more
      </a>
    </CookieConsent>
  );
};

export default CookieConsentForm;
